import Splide from '@splidejs/splide';

document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#image-carousel', {
        heightRatio: 0.5,
        direction          : 'ttb',
        paginationDirection: 'ttb',
        autoplay : true,
        rewind : true,
        rewindByDrag: true,
    } ).mount();
} );